module.exports = __webpack_public_path__ + "static/media/Success.cde7dcaa.png";